<template>
  <div :class="['base-card', { 'base-card--hoverable': hoverable, 'base-card--clickable': clickable }]" @click="clickable ? $emit('click', $event) : null">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  hoverable?: boolean;
  clickable?: boolean;
}>();

defineEmits<{
  click: [event: MouseEvent];
}>();
</script>

<style scoped>
.base-card {
  background: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
}

.base-card--hoverable:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}

.base-card--clickable {
  cursor: pointer;
}

.base-card--clickable:active {
  transform: translateY(-2px);
}
</style>

